import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CurrencyIconElement } from './currencyIconElement';
export const ChipsIconElement = ({ size }) => _jsx(CurrencyIconElement, { color: '#71b8e2', size: size });
